import { Card } from "flowbite-react";
import React from "react";

const AuthSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col md:bg-none bg-gradient-to-br from-indigo-200 via-indigo-200 to-white">
      <div className="flex-1 flex">
        <div className="w-full flex flex-col items-center justify-center p-4 md:p-8 relative">
          <Card
            className="w-full max-w-xl min-h-[500px] flex flex-col items-center justify-center backdrop-blur-sm bg-white/80"
            theme={{
              root: {
                children: "flex h-full flex-col justify-between gap-4 p-6 sm:p-12",
              },
            }}
          >
            {/* Logo Skeleton */}
            <div className="flex w-full justify-center items-center">
              <div className="w-48 h-12 bg-gray-200 animate-pulse rounded-lg"></div>
            </div>

            {/* Subtitle Skeleton */}
            <div className="text-center space-y-2">
              <div className="h-4 w-64 bg-gray-200 animate-pulse rounded mx-auto"></div>
              <div className="h-4 w-48 bg-gray-200 animate-pulse rounded mx-auto"></div>
            </div>

            {/* Form Skeleton */}
            <div className="w-full space-y-6">
              {/* Email Field */}
              <div className="space-y-2">
                <div className="h-4 w-20 bg-gray-200 animate-pulse rounded"></div>
                <div className="h-10 w-full bg-gray-100 animate-pulse rounded-lg"></div>
              </div>

              {/* Password Field */}
              <div className="space-y-2">
                <div className="h-4 w-24 bg-gray-200 animate-pulse rounded"></div>
                <div className="h-10 w-full bg-gray-100 animate-pulse rounded-lg"></div>
              </div>

              {/* Captcha Skeleton (placeholder size) */}
              <div className="flex justify-center">
                <div className="h-[78px] w-[304px] bg-gray-100 animate-pulse rounded"></div>
              </div>

              {/* Button Skeleton */}
              <div className="h-12 w-full bg-indigo-100 animate-pulse rounded-lg"></div>
            </div>

            {/* Footer Text */}
            <div className="text-center pt-4">
              <div className="h-3 w-40 bg-gray-200 animate-pulse rounded mx-auto"></div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AuthSkeleton;
